import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ToggleSwitch from './ToggleSwitch';
import './FilterModal.css';

const EthnicityModal = ({ show, onHide, value, onUpdate }) => {
  const [selectedValue, setSelectedValue] = useState(value || '');
  const [showOthers, setShowOthers] = useState(false);

  const ethnicityOptions = [
    'Yes',
    'Yes and I want more',
    'Yes and I don\'t want more',
    'No, but I want someday',
    'No, but fine if partner has children',
    'No, and I don\'t want any',
    'No'
  ];

  const handleOptionSelect = (option) => {
    setSelectedValue(option);
  };

  const handleApply = () => {
    onUpdate(selectedValue);
    onHide();
  };

  const handleClear = () => {
    setSelectedValue('');
    onUpdate('');
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered className="filter-modal">
      <Modal.Header closeButton>
        <Modal.Title>Do they have children?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="filter-checkbox-group">
          {ethnicityOptions.map((option) => (
            <div
              key={option}
              className={`filter-checkbox-option ${selectedValue === option ? 'selected' : ''}`}
              onClick={() => handleOptionSelect(option)}
            >
              <input
                type="radio"
                id={`ethnicity-${option}`}
                name="ethnicity"
                value={option}
                checked={selectedValue === option}
                onChange={() => handleOptionSelect(option)}
              />
              <label htmlFor={`ethnicity-${option}`}>{option}</label>
            </div>
          ))}
        </div>
        
        {/* Toggle Switch */}
        <ToggleSwitch 
          checked={showOthers} 
          onChange={setShowOthers}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClear} className="filter-modal-btn secondary">
          Clear
        </Button>
        <Button variant="primary" onClick={handleApply} className="filter-modal-btn primary">
          Apply
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EthnicityModal;
